import { SimNaoEnum } from 'components/form/field/SimNaoRadioGroupField'
import { emptyArrayOf } from 'util/array'

import {
  CuidadoCompartilhadoPlanoModel,
  CuidadoCompartilhadoPlanoQueryModel,
  CuidadoCompartilhadoPlanoTableItemModel,
} from '../model-cuidadocompartilhado'

export const joinCuidadosCompartilhado = (
  valoresAtuais: readonly CuidadoCompartilhadoPlanoModel[] | undefined,
  valoresHistorico: ReadonlyArray<CuidadoCompartilhadoPlanoQueryModel>,
  lotacaoAtual: CuidadoCompartilhadoPlanoTableItemModel['lotacaoSolicitante'],
  atendIniciadoEm: Instant
): CuidadoCompartilhadoPlanoTableItemModel[] => {
  return [
    ...(valoresAtuais || emptyArrayOf<CuidadoCompartilhadoPlanoModel>()).map((valorAtual) =>
      convertValorAtualToJoined(valorAtual, lotacaoAtual, atendIniciadoEm)
    ),
    ...(valoresHistorico?.map(convertValorHistoricoToJoined) ??
      emptyArrayOf<CuidadoCompartilhadoPlanoTableItemModel>()),
  ]
}

export const convertValorAtualToJoined = (
  valorAtual: CuidadoCompartilhadoPlanoModel,
  lotacaoAtual: CuidadoCompartilhadoPlanoTableItemModel['lotacaoSolicitante'],
  atendIniciadoEm: Instant
): CuidadoCompartilhadoPlanoTableItemModel => ({
  id: null,
  cacheId: valorAtual._id,
  dataInicioAtendimento: atendIniciadoEm,
  lotacaoExecutanteAtual: valorAtual.lotacao
    ? {
        id: valorAtual.lotacao.id,
        profissional: valorAtual.lotacao.profissional,
      }
    : null,
  cboExecutanteAtual: valorAtual.cbo?.cbo ?? valorAtual.lotacao?.cbo,
  cidadaoAceitaAtendTic: valorAtual.cidadaoAceitaAtendTic === SimNaoEnum.SIM,
  lotacaoSolicitante: {
    id: lotacaoAtual.id,
    cbo: lotacaoAtual.cbo,
    profissional: lotacaoAtual.profissional,
  },
  prioridadeAtual: valorAtual.prioridade,
  discussao: valorAtual.discussao,
  ciap: valorAtual.problemasECondicoes?.ciap,
  cid10: valorAtual.problemasECondicoes?.cid10,
  isRegistradoAgora: true,
})

export const convertValorHistoricoToJoined = (
  valorHistorico: CuidadoCompartilhadoPlanoQueryModel
): CuidadoCompartilhadoPlanoTableItemModel => ({
  id: valorHistorico.id,
  cacheId: null,
  dataInicioAtendimento: valorHistorico.iniciadoEm,
  lotacaoExecutanteAtual: valorHistorico.lotacaoExecutanteAtual,
  cboExecutanteAtual: valorHistorico.cboExecutanteAtual,
  lotacaoSolicitante: valorHistorico.lotacaoSolicitante,
  prioridadeAtual: valorHistorico.classificacaoPrioridadeAtual,
  discussao: valorHistorico.discussao,
  ciap: valorHistorico.ciap,
  cid10: valorHistorico.cid10,
  isRegistradoAgora: false,
  cidadaoAceitaAtendTic: valorHistorico.cidadaoAceitaAtendTic,
})
